import { useState } from "react";
import { useNavigate } from "react-router-dom";
import "../App.css";

export default function AdminLogin() {
  const [user, setUser] = useState("");
  const [pass, setPass] = useState("");

  const navigate = useNavigate();

  const handleLogin = (e) => {
    e.preventDefault();

    const username = user.trim().toLowerCase();
    const password = pass.trim();

    console.log("Username:", username);
    console.log("Password:", password);

    // Login Check
    if (username === "admin" && password === "sunlight@1998") {

      // Save Login Status
      localStorage.setItem("adminAuth", "true");

      alert("Login Successful");

      // Redirect
      navigate("/dashboard");

    } else {
      alert("Wrong username or password!");
    }
  };

  return (
    <div className="login-wrapper">
      <form className="login-box" onSubmit={handleLogin}>

        <h2>Admin Login</h2>

        {/* Username */}
        <input
          type="text"
          placeholder="Enter Username"
          value={user}
          onChange={(e) => setUser(e.target.value)}
          required
        />

        {/* Password */}
        <input
          type="password"
          placeholder="Enter Password"
          value={pass}
          onChange={(e) => setPass(e.target.value)}
          required
        />

        {/* Button */}
        <button type="submit">
          Login
        </button>

      </form>
    </div>
  );
}